import Hamburger from "hamburger-react";
import { useContext, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { Context } from "../../App";
import { auth } from "../../firebase/firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useForm } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import { FullUser } from "../../models/fullUser";
import { UsersApi } from "../../services";

export const Header = () => {
    const [isOpen, setOpen] = useState(false);

    return (
        <div className="flex flex-col">
            <AuthLine />
            {/* <div className={`flex justify-between w-full bg-[url('../public/hl21.jpg')] bg-cover bg-[100px] p-5`} > */}
            <div className={`flex flex-col md:flex-row justify-between w-full p-5`} >
                <div className="mx-auto">
                    {/* <img src={process.env.PUBLIC_URL + "/logo.svg"} alt="logo" /> */}
                    <img src={process.env.PUBLIC_URL + "/logo_big-min.png"} alt="logo2" className="h-48" />
                </div>
                <div className="flex items-center text-5xl flex-grow ">
                    <div className="w-full text-center p-3 rounded-lg">
                        Kočky Brno
                    </div>
                </div>
                <div className="hidden lg:flex">
                    {/* <img src={process.env.PUBLIC_URL + "/logo.svg"} alt="logo" /> */}
                    <img src={process.env.PUBLIC_URL + "/logo_big-min.png"} alt="logo2" className="h-48" />
                </div>
                {/* <div>
                    <img src={process.env.PUBLIC_URL + "/logo_big-min.png"} alt="logo2" className="h-48" />
                </div> */}
            </div>
            <div>

            </div>
            <div className="md:hidden w-full bg-[#DD7E3A]">
                <Hamburger toggled={isOpen} toggle={setOpen} color="white" />
            </div>
            <div className={`${!isOpen ? "hidden md:flex" : ""} flex flex-col md:flex-row w-full bg-[#DD7E3A] justify-center`}>
                <MenuButton label="Home" link="/" setOpen={setOpen} />
                <MenuButton label="Aktuality" link="/actualities" setOpen={setOpen} />
                <MenuButton label="Články" link="/articles" setOpen={setOpen} />
                <MenuButton label="Chov" link="/cats" setOpen={setOpen} />
                <MenuButton label="Výstavy" link="/exhibitions" setOpen={setOpen} />
                <MenuButton label="Členové" link="/members" setOpen={setOpen} />
            </div>
        </div>
    )
}

interface MenuButtonProps {
    label: string,
    link: string,
    setOpen: (opened: boolean) => void,
}

export const MenuButton: React.FC<MenuButtonProps> = ({ label, link, setOpen }) => {
    return (
        <Link to={link}>
            <button className="text-2xl text-white py-3 px-6 hover:bg-[#333333] text-center w-full md:w-auto" onClick={() => setOpen(false)}>
                {label}
            </button>
        </Link>
    )
}

interface LoginForm {
    email: string,
    password: string,
}

export const AuthLine = () => {
    const [user, setUser] = useContext(Context);
    const [errorMsg, setErrorMsg] = useState("");

    const { register, watch } = useForm<LoginForm>();

    const { data: userData } = useQuery<FullUser>({
        queryKey: ["u"],
        queryFn: UsersApi.getCurrentUser,
    });
    const currentUser = userData;

    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await auth.signOut();
            setUser(null);
            console.log("SIGN OUT");
            navigate("/");
            window.location.reload();
        } catch (error) {
            console.log(error);
        }
    }

    const handleLogin = async (e: any) => {
        e.preventDefault()
        try {
            await signInWithEmailAndPassword(auth, watch("email"), watch("password"));
            setErrorMsg("");
            console.log("Logged in");
        } catch (error) {
            setErrorMsg("Nesprávné přihlašovací údaje");
            console.log(error);
        }
    }

    return (
        <div className="flex bg-[#DD7E3A] p-3">
            {
                !user &&
                <form onSubmit={handleLogin} className="flex space-x-5">
                    <div className="flex flex-col md:flex-row space-y-5 md:space-y-0 md:space-x-5">
                        <input
                            className="p-2 text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                            placeholder="E-Mail"
                            {...register("email")}
                        />
                        <input
                            className="p-2 text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                            placeholder="Heslo"
                            {...register("password")}
                            type="password"
                        />
                    </div>
                    <button className="p-2 bg-[#333333] text-white rounded-lg">
                        Přihlásit se
                    </button>
                    <div className="flex items-center">
                        <div>
                            {errorMsg}
                        </div>
                    </div>
                </form>
            }
            {
                user &&
                <div className="space-x-5">
                    <button className="p-2 bg-[#333333] text-white rounded-lg" onClick={() => handleLogout()}>
                        Odhlásit se
                    </button>
                    <Link to="/userpage">
                        <button className="p-2 bg-[#333333] text-white rounded-lg">
                            {user.email}
                        </button>
                    </Link>
                    {
                        currentUser?.role === 1 &&
                        <Link to="/adminpage">
                            <button className="p-2 bg-[#333333] text-white rounded-lg">
                                Adminpage
                            </button>
                        </Link>
                    }
                </div>
            }
        </div>
    )
}
